import React from 'react'
import PropTypes from 'prop-types'

let ProductCheckBox = props => {
  return (
    <div className='ProductCheckbox'>
      <label>
        <input
          type='radio'
          checked={props.active}
          value={props.value}
          onChange={() => props.handleChange(props.value)}
        />
        <div className='radio-check' />
        {props.icon}
        {props.value}
      </label>
    </div>
  )
}

ProductCheckBox.propTypes = {
  active: PropTypes.bool,
  handleChange: PropTypes.func,
  icon: PropTypes.node,
  value: PropTypes.string
}

export default ProductCheckBox
